import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
  InitialLoadIconsSet,
  OtherIconsSet
} from 'src/utils/constants/IconsConstants';

import { colors } from '../../styles/colors';
import {
  getInitialLoadIcons,
  getOtherIcons,
  ZeeFont,
  ZeeFontBold,
  ZeeFontRegular
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { scrollBarStyling } from '../../styles/styles';
import { flex } from '../../styles/utils';

export const Container = styled.div`
  border-radius: 6px;
  background-color: ${colors.AppBgColor};
  ${flex('column', 'center', 'center')};
  max-height: 80vh;
  margin: auto;
  margin-top: 100px;
  max-width: 400px;
  ${MQ.MediaLg} {
    height: 540px;
    width: 340px;
    margin: auto;
    max-height: 85vh;
    position: fixed;
    top: 80px;
    right: 135px;
  }
`;
export const LanguageHeader = styled.div`
  ${flex()};
  width: 100%;
  border-bottom: 1px solid ${colors.PrimaryWhiteColorAlpha50};
`;
export const LanguageBody = styled.div`
  overflow-y: scroll;
  ${scrollBarStyling(
    '5px',
    colors.AccentScrollBarTrack,
    colors.AccentScrollBarBg
  )};

  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 2.5px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2.5px;
    background: ${colors.AccentScrollBarBg};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2.5px;
    background: ${colors.AccentScrollBarTrack};
  }

  ::-webkit-scrollbar-track:hover {
    display: none;
  }
  padding: 0px 15px;
  margin: 34px 30px 15px 0px;
  width: 100%;
  padding-left: 32px;
`;
export const LanguageFooter = styled.div`
  width: 100%;
  gap: 12px;
  ${flex()};
`;
export const Button = styled.button`
  border-radius: 6px;
  background: ${colors.PurpleBtn};
  color: ${colors.white};
  margin-bottom: 32px;
  margin-top: 18px;
  border: none;
  cursor: pointer;
  height: 40px;
  ${ZeeFontBold(14)};
  min-width: 120px;
  ${MQ.MediaLg} {
    width: 185px;
  } ;
`;
export const OutlineButton = styled.button`
  border-radius: 6px;
  background: none;
  color: ${colors.white};
  margin-bottom: 32px;
  margin-top: 18px;
  border: 1px solid ${colors.white};
  cursor: pointer;
  height: 40px;
  ${ZeeFontBold(14)};
  min-width: 120px;
  ${MQ.MediaLg} {
    display: none;
  } ;
`;
export const LanguageButton = styled.button`
  background: none;
  border: none;
  display: none;
  position: relative;
  cursor: pointer;
  color: ${colors.white};
  ${getInitialLoadIcons(InitialLoadIconsSet.LANGUAGE)};
  font-size: 18px;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  background: ${colors.PrimaryWhiteColorAlpha05};
  &:hover {
    background: ${colors.PrimaryWhiteColorAlpha10};
  }
  ${MQ.MediaLg} {
    display: unset;
    margin-right: 4px;
    margin-top: 4px;
  }

  &:hover {
    &:after {
      ${ZeeFont(11, 16)};
      border-radius: 3px;
      left: 50%;
      content: attr(data-tooltip);
      position: absolute;
      bottom: -21px;
      padding: 0 8px;
      min-width: 95px;
      transform: translateX(-50%);
      background: ${colors.TooltipBg};
    }
  }
`;

export const tab = css`
  ${ZeeFontBold(14, 16)};
  width: 100%;
  cursor: pointer;
  ${flex()};
  height: 58px;
  color: ${colors.PrimaryWhiteColorAlpha50};
  padding: 0px 16px;
  ${MQ.MediaLg} {
    height: 70px;
  }
`;

export const tabText = css`
  height: 100%;
  width: 100%;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const active = css`
  color: ${colors.PrimaryWhiteColor};
  border-bottom: 2px solid ${colors.PurpleLight};
`;

export const disableButton = css`
  border: 1px solid ${colors.PrimaryWhiteColorAlpha60};
  background: none;
`;

export const NotificationContainer = styled.div`
  ${flex('row', 'center', 'flex-start')};
  background: ${colors.PrimaryWhiteColorAlpha06};
  gap: 16px;
  padding: 16px;
  width: 100%;
`;

export const BellIcon = styled.div`
  ${getOtherIcons(OtherIconsSet.BELL)};
  width: 86px;
  line-height: 40px;
  height: 40px;
  border-radius: 50%;
  ${flex()};
  background: ${colors.PrimaryWhiteColorAlpha10};
  &:before {
    font-size: 26px;
  }
`;

export const NotificationText = styled.div`
  color: ${colors.PrimaryWhiteColorAlpha80};
  ${ZeeFontRegular(14, 18)};
`;

export const ButttonContainer = styled.div`
  ${flex()};
  position: relative;
`;
